import React from 'react';
import { Offerings as OfferingsSection, Testimonials, CallToAction } from '../components/Sections.jsx';

function OfferingsPage() {
  return (
    <main>
      <OfferingsSection />
      <Testimonials />
      <CallToAction />
    </main>
  );
}

export default OfferingsPage;






